import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';

import { injectCrmSlice } from '@/app/crmApi';

import { RoleReadModel } from './types';

export const crmRolesApi = injectCrmSlice({
  baseUrl: Config.VITE_API_URL,
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getCrmRoles: builder.query<
      RoleReadModel[],
      { organizationId?: string } | void
    >({
      // Only organizationId: a filter hook may hand over its whole query.
      query: args => ({
        url: '/roles',
        params: args ? { organizationId: args.organizationId } : undefined,
      }),
    }),
  }),
});

export const { useGetCrmRolesQuery } = crmRolesApi;
